module.exports = require("!!vue-loader!../../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./solstice.md");


//////////////////
// WEBPACK FOOTER
// ./src/assets/posts/solstice.md
// module id = 29
// module chunks = 2